import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '@auth';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private readonly authService: AuthService,
    private readonly translateService: TranslateService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.headers.get('Authorization') === 'No-Auth') {
      const modifiedRequest = request.clone({
        headers: request.headers.delete('Authorization')
      });
      return next.handle(modifiedRequest);
    }

    if (this.authService.isAuthenticated()) {
      const headers: { [key: string]: string } = {
        'Accept': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Authorization': request.headers.has('Authorization') ?
          request.headers.get('Authorization')! : `Bearer ${this.authService.accessToken}`,
        'TenantId': `${this.authService.currentTenant}`,
        'Accept-Language': this.translateService.currentLang === 'ar' ? 'ar-EG' : 'en-US'
      };

      if (!request.headers.has('Content-Type') && !request.headers.has('X-Skip-Content-Type-Override')) {
        headers['Content-Type'] = 'application/json';
      }

      const modifiedRequest = request.clone({
        setHeaders: headers
      });

      if (modifiedRequest.headers.has('X-Skip-Content-Type-Override')) {
        const finalRequest = modifiedRequest.clone({
          headers: modifiedRequest.headers.delete('X-Skip-Content-Type-Override')
        });
        return next.handle(finalRequest);
      }

      return next.handle(modifiedRequest);
    }

    return next.handle(request);
  }

}
